import { ActivityPrice, ActivityPriceTier } from "backend/api/activities";
import { isArrayEmpty } from "helpers/helpers";

const checkLastPriceTiersCapacity = (
  priceTiers: ActivityPriceTier[],
  activityCapacity: number,
): boolean => {
  if (isArrayEmpty(priceTiers)) return true;
  return priceTiers.at(-1)?.maxQuantity === activityCapacity;
};

export const areLastPricesTiersCapacityValid = (
  prices: ActivityPrice[],
  activityCapacity: number,
) => {
  if (isArrayEmpty(prices)) return true;
  return prices.every((price) => {
    if (price.tiers)
      return checkLastPriceTiersCapacity(price.tiers, activityCapacity);
    else return true;
  });
};

export const checkAndEditPriceTiersMinQuantity = (
  tiers: ActivityPriceTier[],
  setValue: Function,
  priceIndex: number,
) => {
  for (let tierIndex = 1; tierIndex < tiers?.length; tierIndex++) {
    const currentTierMinQuantity = tiers[tierIndex].minQuantity;
    const prevTierMaxQuantity = tiers[tierIndex - 1].maxQuantity;
    const correctCurrentTierMinQuantity = prevTierMaxQuantity + 1;
    if (currentTierMinQuantity !== correctCurrentTierMinQuantity) {
      setValue(
        `prices.${priceIndex}.tiers.${tierIndex}.minQuantity`,
        correctCurrentTierMinQuantity,
      );
    }
  }
};
